<mat-toolbar class="topbar horizontal-topbar p-x-0">
  <div class="container p-x-12">
    <div class="d-none d-sm-flex">
      <app-branding></app-branding>
    </div>

    <!-- Mobile Menu -->
    <button
      mat-icon-button
      (click)="toggleMobileNav.emit()"
      class="d-block d-lg-none"
    >
      <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
    </button>

    <div class="d-none d-lg-flex">
      <a
        *ngFor="let item of secondaryNavigation"
        mat-button
        [routerLink]="[item.route]"
        >{{ item.name }}</a
      >
    </div>

    <span class="flex-1-auto"></span>

    <!-- Mobile Menu -->
    <button
      mat-icon-button
      (click)="toggleMobileFilterNav.emit()"
      class="d-flex d-lg-none justify-content-center"
    >
      <i-tabler name="grid-dots" class="icon-20 d-flex"></i-tabler>
    </button>

    <!-- Langugage Dropdown -->
    <button [matMenuTriggerFor]="flags" mat-icon-button class="m-r-5">
      <img
        [src]="selectedLanguage.icon"
        class="rounded-circle object-cover icon-20"
      />
    </button>
    <mat-menu #flags="matMenu" class="cardWithShadow">
      <button
        mat-menu-item
        *ngFor="let lang of languages"
        (click)="changeLanguage(lang)"
      >
        <div class="d-flex align-items-center">
          <img
            [src]="lang.icon"
            class="rounded-circle object-cover m-r-8 icon-20"
          />
          <span class="mat-subtitle-1 f-s-14">{{ lang.language }}</span>
        </div>
      </button>
    </mat-menu>

    <!-- Notification Dropdown -->
    <button
      mat-icon-button
      [matMenuTriggerFor]="notificationmenu"
      aria-label="Notifications"
    >
      <i-tabler
        class="d-flex"
        name="bell"
        [matBadge]="(unreadCount$ | async) || null"
        [matBadgeHidden]="(unreadCount$ | async) === 0"
        matBadgeColor="primary"
      ></i-tabler>
    </button>
    <mat-menu
      #notificationmenu="matMenu"
      xPosition="before"
      class="topbar-dd cardWithShadow"
    >
      <div class="d-flex align-items-center p-x-32 p-y-16">
        <h6 class="f-s-16 f-w-600 m-0">{{ notifKeys.title | translate }}</h6>
        <span class="m-l-auto" *ngIf="(unreadCount$ | async) as count">
          <span class="bg-primary text-white p-x-8 p-y-4 f-w-500 rounded f-s-12"
            >{{ count }} {{ notifKeys.newBadge | translate }}</span
          >
        </span>
      </div>
      <ng-container *ngIf="(latestNotifications$ | async) as notifications">
        <button
          mat-menu-item
          class="p-x-32 p-y-16"
          *ngFor="let notification of notifications"
          (click)="onNotificationClick(notification)"
        >
          <div class="d-flex align-items-center">
            <mat-icon
              class="m-r-16"
              [color]="notification.isRead ? '' : 'primary'"
            >
              {{ notification.isRead ? 'notifications_none' : 'notifications_active' }}
            </mat-icon>
            <div class="m-l-8">
              <h5
                class="f-s-14 m-0 mat-subtitle-1"
                [class.f-w-600]="!notification.isRead"
                [class.f-w-400]="notification.isRead"
              >
                {{ notification.title }}
              </h5>
              <span class="f-s-12">{{ notification.message }}</span>
              <span class="f-s-10 d-block m-t-4 mat-hint" *ngIf="notification.created">
                {{ notification.created | date:'short' }}
              </span>
            </div>
          </div>
        </button>
        <div *ngIf="notifications.length === 0" class="p-x-32 p-y-16 text-center">
          <span class="mat-hint">{{ notifKeys.noNotifications | translate }}</span>
        </div>
      </ng-container>
      <div class="p-y-12 p-x-32">
        <button mat-stroked-button color="primary" class="w-100" (click)="goToInbox()">
          {{ notifKeys.seeAll | translate }}
        </button>
      </div>
    </mat-menu>

    <!-- Profile Dropdown -->
    <button
      mat-icon-button
      [matMenuTriggerFor]="profilemenu"
      aria-label="Notifications"
    >
      <img
        src="/assets/images/profile/user-1.jpg"
        class="rounded-circle object-cover"
        width="35"
      />
    </button>
    <mat-menu
      #profilemenu="matMenu"
      xPosition="before"
      class="topbar-dd cardWithShadow"
    >
      <div class="p-x-32 p-y-16">
        <h6 class="f-s-16 f-w-600 m-0">User Profile</h6>

        <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16">
          <img
            src="/assets/images/profile/user-1.jpg"
            class="rounded-circle"
            width="95"
          />
          <div class="m-l-16">
            <h6 class="f-s-14 f-w-600 m-0">Mathew Anderson</h6>
            <span class="f-s-14 d-block m-b-4">Designer</span>
            <a
              type="button"
              [routerLink]="['/app/profile']"
              mat-flat-button
              color="primary"
              class="m-t-8"
            >
              {{ commonKeys.others.viewProfile | translate }}
            </a>
          </div>
        </div>
      </div>

      <div class="p-y-12 p-x-32">
        <a (click)="logout()" mat-stroked-button color="warn">{{ commonKeys.actions.logout | translate }}</a>
      </div>
    </mat-menu>
  </div>
</mat-toolbar>
